import BaseDevice from '../base.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {
      return this.getDevice(device, scale, false, true);
   }

   static getTextPadding = (device, DEFAULT_PADDING) => {
      if (!device.height) {
         return DEFAULT_PADDING;
      }
      return DEFAULT_PADDING * device.height / 100
   }

   static getHeight = (device) => {
      let portLines = 0;
      ['top', 'top2', 'bottom2', 'bottom'].forEach(loc => {
         if (device[`${loc}Ports`] > 0) {
            portLines++
         }
      })

      return portLines * 60
   }

   static getWireColor = (device) => {
      return getRGBColorByColors(device.bgColor)
   }

   static getWireDirection = (device, position) => {
      return position.includes("top") ? (device.twisted ? 'Left' : 'Top') : (device.twisted ? 'Right' : 'Bottom')
      // console.log(position);
      // switch (position) {
      //    case 'top' :
      //       return device.twisted
      // }

      // if (device.twisted == 'bottom') {
      //    return 'top';
      // }
      // return 'bottom';
   }

   static getPortY = (device, position, screwWidth, height) => {
      switch (position) {
         case 'top': {
            return this.getScrewsPaddingY();
         }
         case 'top2': {
            const topPortWidth = this.getScrewWidthAndSpace(device, 'top')[0] * (device.topPorts > 0);
            return topPortWidth + this.getScrewsPaddingY();
         }
         case 'bottom2': {
            const bottomPortWidth = this.getScrewWidthAndSpace(device, 'bottom')[0] * (device.bottomPorts > 0);
            return height - bottomPortWidth - this.getScrewsPaddingY() - screwWidth
         }
         case 'bottom': {
            return height - screwWidth - this.getScrewsPaddingY();
         }
      }
   }

   static getTextPadding = (device, DEFAULT_PADDING) => { // see generic device
      return this.getHeight(device) / 2;
   }



   static getRowsSpace = () => {
      return 5;
   }

   static getScrewsPaddingY = () => {
      return 10;
   }

}
